<template>
  <Teleport to="body">
    <div id="modal">
      <slot></slot>
    </div>
  </Teleport>
</template>

<style scoped>
#modal:not(:empty) {
  @apply fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-50 flex justify-center items-center;
}
</style>
